import { cn } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { PRICE_COL, STATUS_COL, TIME_COL } from './PaymentRow'

/** Заголовки колонок истории покупок — на тех же ширинах, что и строки. */
export const PaymentsHeader = () => {
  const m = useMessages(messages)
  return (
    <div className="flex items-center gap-3 border-b border-foreground/5 pb-3 text-xs text-muted-foreground sm:gap-4">
      <span className={TIME_COL}>{m.colTime}</span>
      <span className="min-w-0 flex-1">{m.colAmount}</span>
      <span className={PRICE_COL}>{m.colPrice}</span>
      <span className={cn(STATUS_COL, 'pr-3')}>{m.colStatus}</span>
    </div>
  )
}
